import React,{useEffect} from 'react';
import successGif from '../../images/thank-you3.gif'
import "./Success&ErrorPopups.css"
import { Button, Modal, ModalBody } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { registrationSuccessModalToggle } from '../../redux/actions/Index';

function RegisterPopup() {
    const registrationSuccessToggle = useSelector((state)=>state?.ModalReducer?.registrationSuccessToggle);
    const dispatch = useDispatch()
    const closeModal = () =>{
        dispatch(registrationSuccessModalToggle())
    };

    useEffect(() => {
    if(registrationSuccessToggle){
        setTimeout(() => {
          closeModal()
        }, 3000);
    }
    }, [registrationSuccessToggle])
    
    return (
        <div>
            <Modal isOpen={registrationSuccessToggle} className="modal-style">
                <ModalBody className="py-1">
                    <div className="d-flex justify-content-center align-items-center flex-column gap-3">
                        <div className="cards-img-55 ">
                            <img src={successGif} alt="SuccessGif" className="img-fit" />
                        </div>
                        <label className="title-font-bold fs-1 mb-0 text-center text-capitalize  text-base-color">Thank You..!</label>
                        <label className="mb-2 fs-3 text-center text-capitalize  base-font-600 ">Account has been successfully registered.</label>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default RegisterPopup; 